import { render, staticRenderFns } from "./ProductBenefits.vue?vue&type=template&id=468f7d6f"
import script from "./ProductBenefits.vue?vue&type=script&lang=js"
export * from "./ProductBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports